import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core'
import { interval, Subscription } from 'rxjs'
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min'

@Component({
    selector: 'fm-display-timezone-local-time',
    imports: [],
    templateUrl: './display-timezone-local-time.component.html',
    styleUrl: './display-timezone-local-time.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayTimezoneLocalTimeComponent {
    @Input() timezone!: string
    @Input() epoch?: number

    displayTime: string = ''
    private timerSubscription?: Subscription
    private initialTimeout: any

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.updateTime()

        // Only set up live updates if no epoch is provided.
        if (!this.epoch) {
            // Calculate delay until the beginning of the next minute.
            const now = new Date()
            const seconds = now.getSeconds()
            const milliseconds = now.getMilliseconds()
            const delay = (60 - seconds) * 1000 - milliseconds

            // Trigger at the next minute boundary.
            this.initialTimeout = setTimeout(() => {
                this.updateTime()
                this.timerSubscription = interval(60000).subscribe(() => this.updateTime())
            }, delay)
        }
    }

    updateTime(): void {
        const currentMoment = this.epoch ? moment(this.epoch) : moment()
        this.displayTime = currentMoment.tz(this.timezone).format('h:mma')
        this.cdr.markForCheck()
    }

    ngOnDestroy(): void {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe()
        }
        if (this.initialTimeout) {
            clearTimeout(this.initialTimeout)
        }
    }
}
